'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssigneeIdForAssignmentMessage = undefined;

var _getters = require('./getters');

var _getAgentId = require('../../pubnub-message/operators/getAgentId');

var _isAssignmentV = require('../../pubnub-message/operators/isAssignmentV2');

var getAssigneeIdForAssignmentMessage = exports.getAssigneeIdForAssignmentMessage = function getAssigneeIdForAssignmentMessage(message) {
  return (0, _isAssignmentV.isAssignmentV2)(message) ? (0, _getters.getAssignedAgentId)(message) : (0, _getAgentId.getAgentId)(message);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/assignment-message/getAssigneeIdForAssignmentMessage.js
// module id = 812
// module chunks = 2 3